var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup45721(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86612 7.20563L3.55729 9.58302C3.47908 10.185 3.26489 10.7613 2.93092 11.2683L1.6597 13.1979C1.22936 13.8512 1 14.6162 1 15.3985V15.676C1 17.8851 2.79086 19.676 5 19.676H17C19.2091 19.676 21 17.8851 21 15.676V15.4552C21 14.6376 20.7495 13.8397 20.2822 13.1688L18.9802 11.2998C18.6132 10.7729 18.3784 10.1655 18.2957 9.52873L17.9939 7.20563C17.5328 3.65612 14.5094 1 10.93 1C7.35069 1 4.32721 3.65612 3.86612 7.20563Z",
    stroke: "#333747",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91663 22.4077C8.46539 23.5595 9.64031 24.3556 11.0012 24.3556C12.362 24.3556 13.5369 23.5595 14.0857 22.4077",
    stroke: "#333747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup45721);
export default __webpack_public_path__ + "static/media/Group 4572 (1).d9ff41441801d5647d4e96dba8d0114a.svg";
export { ForwardRef as ReactComponent };